/*
 * BulkImportManager actions
 */

import { createAction } from '@reduxjs/toolkit';
import {
  // Main Actions
  UPLOAD_FILE,
  UPLOAD_FILE_PROGRESS,
  ANALYZE_FILE,
  GET_REQUIRED_FIELDS,
  CREATE_IMPORT_JOB,

  // WebSocket
  WEBSOCKET_CONNECT,
  WEBSOCKET_STATUS,

  // Job Progress
  JOB_PROGRESS,

  // Column Mapping
  UPDATE_COLUMN_MAPPING,
  CLEAR_COLUMN_MAPPING,

  // Navigation
  SET_CURRENT_STEP,
  GO_TO_NEXT_STEP,

  // Reset
  RESET_ALL,

  // Utility
  CLEANUP,
  SELECT_IMPORT_TYPE,
} from './constants';

// Main Actions with loadingState pattern
export const uploadFileAct = createAction(
  UPLOAD_FILE,
  (loadingState, file, progress, uploadId, fileId) => ({
    payload: {
      loadingState,
      file,
      progress,
      uploadId,
      fileId,
    },
  }),
);

export const uploadFileProgressAct = createAction(UPLOAD_FILE_PROGRESS);

export const analyzeFileAct = createAction(
  ANALYZE_FILE,
  (loadingState, analysisResult) => ({
    payload: {
      loadingState,
      analysisResult,
    },
  }),
);

export const getRequiredFieldsAct = createAction(
  GET_REQUIRED_FIELDS,
  (loadingState, requiredFields) => ({
    payload: {
      loadingState,
      requiredFields,
    },
  }),
);

export const createImportJobAct = createAction(
  CREATE_IMPORT_JOB,
  (loadingState, columnMapping, job) => ({
    payload: {
      loadingState,
      columnMapping,
      job,
    },
  }),
);

// WebSocket Actions
export const websocketConnectAct = createAction(WEBSOCKET_CONNECT);
export const websocketStatusAct = createAction(
  WEBSOCKET_STATUS,
  isConnected => ({
    payload: {
      isConnected,
    },
  }),
);

// Job Progress Actions (triggered by WebSocket)
export const jobProgressAct = createAction(JOB_PROGRESS);

// Column Mapping Actions
export const updateColumnMappingAct = createAction(UPDATE_COLUMN_MAPPING);
export const clearColumnMappingAct = createAction(CLEAR_COLUMN_MAPPING);

// Navigation Actions
export const setCurrentStepAct = createAction(SET_CURRENT_STEP);
export const goToNextStepAct = createAction(GO_TO_NEXT_STEP);

// Set import type
export const selectImportTypeAct = createAction(SELECT_IMPORT_TYPE);
// Reset Actions
export const resetAllAct = createAction(RESET_ALL);

// Utility Actions
export const cleanupAct = createAction(CLEANUP);
